import React from 'react';
import cn from 'classnames';
import Icon from '../assets/images/icon-review.svg';
import * as styles from './index.module.css';

type TitleSize = 'xLarge' | 'large';

type EmptyLayoutArgs = {
  hasIcon?: boolean;
  icon?: React.ReactNode;
  title: string;
  titleSize?: TitleSize;
  description?: React.ReactNode;
  additionalInfo?: React.ReactNode;
  className?: string;
};
export type EmptyLayoutProps = React.PropsWithChildren<EmptyLayoutArgs>;

export function EmptyLayout({
  hasIcon = true,
  icon,
  title,
  titleSize = 'xLarge',
  description,
  additionalInfo,
  children,
  className = '',
}: EmptyLayoutProps) {
  return (
    <div className={cn([styles.wrapper, className])}>
      {hasIcon && (
        <div className={styles.iconContainer}>
          {icon ?? (
            <div className={styles.cirlceBlock}>
              <div className={styles.lightCircle}>
                <div className={styles.blueCircle}>
                  <img className={styles.img} src={Icon} alt="" />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <div className={styles.titleAndDescription}>
        <h1 className={cn([styles.title, styles[titleSize]])}>{title}</h1>
        {description ? <div className={styles.description}>{description}</div> : null}
      </div>
      <div className={styles.childrenAndAdditionalInfo}>
        {children ? <div className={styles.childrenContainer}>{children}</div> : null}
        {additionalInfo ? <div className={styles.additionalInfo}>{additionalInfo}</div> : null}
      </div>
    </div>
  );
}
